import React from 'react';
import PropTypes from 'prop-types';

const STATUS_STYLES = {
  PENDING: {
    background: '#ff9e22',
    color: '#fff',
  },
  LOADED: {
    background: '#368007',
    color: '#fff',
  },
  RECEIVED: {
    background: '#007aff',
    color: '#fff',
  },
  VARIANCE: {
    background: '#d9283f',
    color: '#fff',
  },
};

const StatusBadge = ({ status, count, showCount = true }) => {
  const statusStyle = STATUS_STYLES[status] || STATUS_STYLES.PENDING;
  const displayText =
    showCount && count !== undefined ? `${count} ${status}` : status;

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '8px 16px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        minWidth: '80px',
        ...statusStyle,
      }}
    >
      {displayText}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['PENDING', 'LOADED', 'RECEIVED', 'VARIANCE'])
    .isRequired,
  count: PropTypes.number,
  showCount: PropTypes.bool,
};

StatusBadge.defaultProps = {
  count: undefined,
  showCount: true,
};

export default StatusBadge;
const DEFAULT_STATUS = STATUS_STYLES.PENDING;

export { STATUS_STYLES, DEFAULT_STATUS };
